export default "__VITE_PUBLIC_ASSET__2e892381__"